// Package imports:
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
// Component imports:
import Entrypoint from '../Entrypoint';
import WatchPage from '../../components/Watch/Watch';


const Watch: React.FC = () => {
    const helmetContext = {};
    return (
        <HelmetProvider context={helmetContext}>
            <Entrypoint>
                <WatchPage />
            </Entrypoint>
        </HelmetProvider>
    );
}

export default Watch;